// Marquette's undergraduate majors (#2840). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Bulletin's Programs page
// (bulletin.marquette.edu/programs/), filtered to Majors: every program the
// bulletin tags Major and Undergraduate kept, grouped by the college tag it
// carries; minors, concentrations (including "Spanish for Health Care
// (Introductory), Concentration", which the bulletin also tags Major),
// certificates and graduate programs left out. Degree abbreviations are the
// bulletin's own (BA, BS, BSN, BBE, BCE, ...); where the bulletin writes only
// "Major" in place of a degree, degree is null. The four teacher-education
// majors carry both the Arts and Sciences and Education tags and sit in their
// own group. The KB's majors list was the starting point; the bulletin wins.
const majors = {
    "slug": "marquette-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Marquette's official 2026-2027 Undergraduate Bulletin, grouped by the college that offers it, with the degree it leads to. Minors, concentrations, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Klingler College of Arts and Sciences",
            "source": {
                "label": "Marquette Undergraduate Bulletin 2026-2027, Programs (Majors)",
                "url": "https://bulletin.marquette.edu/programs/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematical Economics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BS"
                },
                {
                    "name": "Computational Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminology and Law Studies",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Gender and Sexualities Studies",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Middle East and North Africa Studies",
                    "degree": "BA"
                },
                {
                    "name": "Peace Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Social Welfare and Justice",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish for the Professions",
                    "degree": "BA"
                },
                {
                    "name": "Spanish Language, Literature and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Statistical Science",
                    "degree": "BS"
                },
                {
                    "name": "Theology and Religion",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Business Administration",
            "source": {
                "label": "Marquette Undergraduate Bulletin 2026-2027, Programs (Majors)",
                "url": "https://bulletin.marquette.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Applied Artificial Intelligence in Business",
                    "degree": null
                },
                {
                    "name": "Applied Investment Management",
                    "degree": null
                },
                {
                    "name": "Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Business Analytics",
                    "degree": null
                },
                {
                    "name": "Business Economics",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Human Resources",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "International Business",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Operations and Supply Chain Management",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Diederich College of Communication",
            "source": {
                "label": "Marquette Undergraduate Bulletin 2026-2027, Programs (Majors)",
                "url": "https://bulletin.marquette.edu/programs/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Corporate Communication",
                    "degree": "BA"
                },
                {
                    "name": "Digital Media",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Public Relations",
                    "degree": "BA"
                },
                {
                    "name": "Sports Communication",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Marquette Undergraduate Bulletin 2026-2027, Programs (Majors)",
                "url": "https://bulletin.marquette.edu/programs/"
            },
            "majors": [
                {
                    "name": "Educational Studies",
                    "degree": "BS"
                },
                {
                    "name": "Elementary/Middle Education",
                    "degree": "BS"
                },
                {
                    "name": "Middle/Secondary Education",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Klingler College of Arts and Sciences with the School of Education",
            "source": {
                "label": "Marquette Undergraduate Bulletin 2026-2027, Programs (Majors)",
                "url": "https://bulletin.marquette.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biology and Science Education Grades 4-12",
                    "degree": null
                },
                {
                    "name": "Chemistry and Science Education Grades 4-12",
                    "degree": null
                },
                {
                    "name": "Mathematics for Elementary School Teachers (MELT)",
                    "degree": null
                },
                {
                    "name": "Teaching Science Grades K-9",
                    "degree": null
                }
            ]
        },
        {
            "name": "Opus College of Engineering",
            "source": {
                "label": "Marquette Undergraduate Bulletin 2026-2027, Programs (Majors)",
                "url": "https://bulletin.marquette.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biocomputing",
                    "degree": "BBE"
                },
                {
                    "name": "Bioelectronics",
                    "degree": "BBE"
                },
                {
                    "name": "Biomechanics",
                    "degree": "BBE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BCE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BCO"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "BCN"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BEE"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BCE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BME"
                }
            ]
        },
        {
            "name": "College of Health Sciences",
            "source": {
                "label": "Marquette Undergraduate Bulletin 2026-2027, Programs (Majors)",
                "url": "https://bulletin.marquette.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biomedical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Physiology",
                    "degree": "BS"
                },
                {
                    "name": "Speech Pathology and Audiology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Marquette Undergraduate Bulletin 2026-2027, Programs (Majors)",
                "url": "https://bulletin.marquette.edu/programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        }
    ]
};

export default majors;
